import { splitInstanceBasePath } from "@/lib/dashboard-routes";
import {
  GTM_NEW_GITHUB_SIGNUP_QUERY,
  GTM_SIGNUP_CONVERSION_ID_QUERY,
} from "@/lib/githubAuthGtm";

export const INSTALL_RETURN_PARAM = "return_to";

/**
 * A same-origin dashboard path, as the backend's GithubAppInstallReturnPath
 * accepts: `/sessions/new?prompt=x` passes; `//evil.example`,
 * `/\evil.example` and `https://evil.example` do not. Welcome itself is
 * refused too, since an installed user's welcome page redirects to it.
 */
export function parseInstallReturnPath(
  value: string | null | undefined,
): string | undefined {
  if (
    !value ||
    !value.startsWith("/") ||
    value.startsWith("//") ||
    value.includes("\\") ||
    /\p{Cc}/u.test(value) ||
    isWelcomePath(value)
  ) {
    return undefined;
  }
  return value;
}

function isWelcomePath(path: string): boolean {
  const pathname = path.split(/[?#]/, 1)[0];
  return /^\/welcome\/?$/.test(splitInstanceBasePath(pathname).pathname);
}

/** `/sessions/new?prompt=x` → `/welcome?return_to=%2Fsessions%2Fnew%3Fprompt%3Dx`; an instance root carries nothing. */
export function welcomePathFor(
  instanceBase: string,
  { pathname, search, hash }: Pick<Location, "pathname" | "search" | "hash">,
): string {
  const welcome = `${instanceBase}/welcome`;
  if (splitInstanceBasePath(pathname).pathname === "/") return welcome;
  // Replaying the signup markers after the install would report the signup twice.
  const query = new URLSearchParams(search);
  query.delete(GTM_NEW_GITHUB_SIGNUP_QUERY);
  query.delete(GTM_SIGNUP_CONVERSION_ID_QUERY);
  const queryString = query.toString();
  const returnTo = `${pathname}${queryString ? `?${queryString}` : ""}${hash}`;
  return `${welcome}?${new URLSearchParams({
    [INSTALL_RETURN_PARAM]: returnTo,
  })}`;
}
